import React from 'react';
import PropTypes from 'prop-types';
import 'reset-css/reset.css';
import '../color/color';
import '../grid/grid';
import '../rule/rule';
import '../typography/typography';
import css from './table.css';

const Table = ({ children, scroll }) => (
  <div className={scroll ? css['ds-table--scroll'] : null}>
    <table className={css['ds-table']}>{children}</table>
  </div>
);

Table.defaultProps = {
  children: null,
  scroll: false,
};

Table.propTypes = {
  children: PropTypes.node,
  scroll: PropTypes.bool,
};

export default Table;
